<template>
  <v-container fluid>
    <!-- Saludo -->
    <v-row>
      <v-col cols="12">
        <v-alert type="success" outlined>
          Bienvenido al Portal de Proveedores, {{ usuario.nombre }}.
        </v-alert>
      </v-col>
    </v-row>

    <!-- Tarjetas resumen -->
    <v-row>
      <v-col cols="12" sm="6" md="3" v-for="card in cards" :key="card.title">
        <v-card outlined>
          <v-card-title>
            <v-icon large class="mr-2">{{ card.icon }}</v-icon>
            <span>{{ card.title }}</span>
          </v-card-title>
          <v-card-text class="text-h5 text-center">{{ card.value }}</v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Alertas / Notificaciones -->
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-bell-alert</v-icon> Alertas recientes
          </v-card-title>
          <v-divider></v-divider>
          <v-list dense>
            <v-list-item v-for="(alert, i) in alerts" :key="i">
              <v-list-item-icon>
                <v-icon color="red">mdi-alert-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ alert.title }}</v-list-item-title>
                <v-list-item-subtitle>{{ alert.subtitle }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>

      <!-- Gráfico de pedidos -->
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title>
            <v-icon class="mr-2">mdi-chart-line</v-icon> Pedidos últimos 7 días
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-sparkline
              :value="sparklineData"
              line-width="3"
              color="primary"
            ></v-sparkline>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data() {
    return {
      usuario: JSON.parse(localStorage.getItem('usuario') || '{}'),
      // Tarjetas de resumen
      cards: [
        { title: 'Pedidos Pendientes', value: 12, icon: 'mdi-cart' },
        { title: 'Documentos Pendientes', value: 8, icon: 'mdi-file-document-box' },
        { title: 'Stock Disponible', value: 150, icon: 'mdi-warehouse' },
        { title: 'Usuarios Activos', value: 5, icon: 'mdi-account-group' },
      ],
      // Alertas simuladas
      alerts: [
        { title: 'Pedido 123 retrasado', subtitle: 'Fecha de entrega vencida' },
        { title: 'Documento pendiente de revisión', subtitle: 'Factura 456' },
        { title: 'Nuevo mensaje del comprador', subtitle: 'Revisar mensajes' },
      ],
      // Datos del gráfico
      sparklineData: [10, 15, 12, 20, 18, 25, 22]
    }
  }
}
</script>

<style scoped>
.v-card {
  transition: 0.2s;
}
.v-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
}
</style>
